import {
  ClassificationConfig,
  ExtractionConfig,
  ValidationConfig,
} from "../../../interfaces/doc";

export const getClassificationQueries = (
  classification: ClassificationConfig | null | undefined
) => {
  if (!classification) return 0;
  else
    return classification.queries.flatMap((query) => {
      if ("queries" in query) {
        return query.queries.map((nestedQuery) => nestedQuery);
      } else {
        return [query];
      }
    }).length;
};

export const getExtractionQueries = (
  extraction: ExtractionConfig | null | undefined
) => {
  if (!extraction) return 0;
  else
    return extraction.queries.flatMap((query) => {
      if ("queries" in query) {
        return query.queries.map((nestedQuery) => nestedQuery);
      } else {
        return [query];
      }
    }).length;
};

export const getValidationRules = (
  validation: ValidationConfig | null | undefined
) => {
  if (!validation) return 0;
  else {
    return (
      (validation.asset_rules ? validation.asset_rules.length : 0) +
      (validation.document_rules ? validation.document_rules.length : 0)
    );
  }
};
